const state = {
  alertaError: {
    mensaje: '',
    tiempo: 0,
    visibilidad: false,
  },
  alertaExito: {
    mensaje: '',
    tiempo: 0,
    visibilidad: false,
  },
}

const getters = {
  obtenerDatosAlertaError(state) {
    return state.alertaError
  },
  obtenerDatosAlertaExito(state) {
    return state.alertaExito
  },
}

const mutations = {
  establecerAlertaError(state, payload) {
    state.alertaError = payload
  },
  restablecerAlertaError(state) {
    state.alertaError.mensaje = ''
    state.alertaError.tiempo = 0
    state.alertaError.visibilidad = false
  },
  establecerAlertaExito(state, payload) {
    state.alertaExito = payload
  },
  restablecerAlertaExito(state) {
    state.alertaExito.mensaje = ''
    state.alertaExito.tiempo = 0
    state.alertaExito.visibilidad = false
  },
}

const actions = {
  enviarAlertaError(context, payload) {
    context.commit('establecerAlertaError', payload)
  },
  restablecerAlertaError(context) {
    context.commit('restablecerAlertaError')
  },
  enviarAlertaExito(context, payload) {
    context.commit('establecerAlertaExito', payload)
  },
  restablecerAlertaExito(context) {
    context.commit('restablecerAlertaExito')
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
